module.exports = __webpack_public_path__ + "img/Villa_Borna_56.195e400c.jpg";